import Layout from "@views/layout";

const activityRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
            path: "challenge",
            name: "CHALLENGE",
            meta: {
                title: "挑战管理",
                sort: 1,
            },
            component: () => import("@views/challenge/index.vue"),
            redirect: {
                name: "CHALLENGE_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "CHALLENGE_LIST",
                    meta: {
                        title: "每日一答",
                        parentPath: '/business/activity/list',
                        operate: true,
                    },
                    component: () => import("@views/challenge/dailyanswer.vue"),
                },
                {
                    path: "week",
                    name: "CHALLENGE_WEEk",
                    meta: {
                        title: "每周一答",
                        parentPath: '/business/activity/list',
                        operate: true,
                    },
                    component: () => import("@views/challenge/everyweek.vue"),
                },
                {
                    path: "lecturehall",
                    name: "CHALLENGE_LECTURE",
                    meta: {
                        title: "大讲堂授课",
                        parentPath: '/business/activity/list',
                        operate: true,
                    },
                    component: () => import("@views/challenge/lecturehall.vue"),
                },
                {
                    path: "circleactivities",
                    name: "CHALLENGE_CIRCLEACTIVITIES",
                    meta: {
                        title: "圈子活动参与证明",
                        parentPath: '/business/activity/list',
                        operate: true,
                    },
                    component: () => import("@views/challenge/circleactivities.vue"),
                },
                {
                    path: "circlespeech",
                    name: "CHALLENGE_CIRCLESPEECH",
                    meta: {
                        title: "提交圈子演讲参与证明",
                        parentPath: '/business/activity/list',
                        operate: true,
                    },
                    component: () => import("@views/challenge/circlespeech.vue"),
                },
                {
                    path: "write",
                    name: "CHALLENGE_WRITE",
                    meta: {
                        title: "撰写技术文章",
                        parentPath: '/business/activity/list',
                        operate: true,
                    },
                    component: () => import("@views/challenge/write.vue"),
                },
                {
                    path: "shortvideo",
                    name: "CHALLENGE_SHORTVIDEO",
                    meta: {
                        title: "短视频创作",
                        parentPath: '/business/activity/list',
                        operate: true,
                    },
                    component: () => import("@views/challenge/shortvideo.vue"),
                },
                {
                    path: "orderproof",
                    name: "CHALLENGE_OPERPROOF",
                    meta: {
                        title: "提交项目下单证明",
                        parentPath: '/business/activity/list',
                        operate: true,
                    },
                    component: () => import("@views/challenge/orderproof.vue"),
                },
                {
                    path: "hcsxhcix",
                    name: "CHALLENGE_HCSXHCIX",
                    meta: {
                        title: "HCSX/HCIX证书",
                        parentPath: '/business/activity/list',
                        operate: true,
                    },
                    component: () => import("@views/challenge/hcsxhcix.vue"),
                },
                {
                    path: "eventposter",
                    name: "CHALLENGE_EVENTPOSTER",
                    meta: {
                        title: "赛事海报",
                        parentPath: '/business/activity/list',
                        operate: true,
                    },
                    component: () => import("@views/challenge/eventposter.vue"),
                },
            ],
        },

    ],
};
export default activityRouter;